import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService implements OnDestroy {

  isSpinner = false;

  private readonly routesSubscription: Subscription;

  constructor(private spinner: NgxSpinnerService) {
  }

  ngOnDestroy() {
    if (this.routesSubscription) {
      this.routesSubscription.unsubscribe();
    }
  }

  start(name = 'main-spinner') {
    this.isSpinner = true;
    this.spinner.show(name);
  }

  stop(name = 'main-spinner') {
    this.isSpinner = false;
    this.spinner.hide(name);
  }

  async onOffSpinner(name) {
    await this.spinner.show(name);

    setTimeout(async () => {
      await this.spinner.hide(name);
    }, 3000);
  }

}
